/*eslint-disable*/
import { Link } from 'react-router-dom';
// @mui/material components
import { useTheme } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import {Container, Tooltip, IconButton} from "@mui/material";
// core components
import styles from "../assets/jss/material-dashboard-react/components/footerStyle.js";


export default function Footer(props) {
  const { type } = props;
  //const theme = useTheme()
  //const classes = styles(theme);


  function rout() {
    return type;
  }

  return (
    <div className="bg-first text-white font-weight-bold">
    <footer sx={styles.footer}>
      <div sx={styles.container}>
        <div sx={styles.left}>
          <List sx={styles.list}>
            <ListItem sx={styles.inlineBlock}>
              <Link to={`/${rout()}/home`}>
              <div className="text-white-50 d-block pt-3">
                Home
              </div>
              </Link>
            </ListItem>
            <ListItem sx={styles.inlineBlock}>
            <Link to={`/${rout()}/dashboard`}>
              <div className="text-white-50 d-block pt-3">
                Dashboard
              </div>
            </Link>
            </ListItem>
            <ListItem sx={styles.inlineBlock}>
            <Link to={`/${rout()}/user`}>
              <div className="text-white-50 d-block pt-3">
                My profile
              </div>
            </Link>
            </ListItem>
           
          </List>
        </div>

        <Container maxWidth="md" className="text-center">
          <h1 className="font-size-lg text-white-50">
                Follow us here
          </h1>
             

          <div className="d-flex justify-content-center">
            <Tooltip arrow title="Facebook">
              <IconButton className="nav-link text-white-50">
                <span className="btn-wrapper--icon">
                    <a className="btn btn-social-icon btn-facebook" href="http://www.facebook.com/profile.php?id=">
                      <i className="fa fa-facebook"></i>
                    </a>
                </span>
              </IconButton>
            </Tooltip>
              <Tooltip arrow title="Twitter">
                <IconButton className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                  <a className="btn btn-social-icon btn-twitter" href="http://twitter.com/"><i className="fa fa-twitter"></i></a>
                  </span>
                  </IconButton>
              </Tooltip>
              <Tooltip arrow title="Google+">
                <IconButton
                  className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                  <a className="btn btn-social-icon btn-google" href="http://google.com/+"><i className="fa fa-google-plus"></i></a>
                  </span>
                </IconButton>
              </Tooltip>
              <Tooltip arrow title="Youtube">
                <IconButton
                  className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                  <a className="btn btn-social-icon btn-google" href="http://youtube.com/"><i className="fa fa-youtube"></i></a>
                  </span>
                </IconButton>
              </Tooltip>
              <Tooltip arrow title="LinkedIn">
                <IconButton
                  className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                  <a className="btn btn-social-icon btn-linkedin" href="http://www.linkedin.com/in/"><i className="fa fa-linkedin"></i></a>
                  </span>
                </IconButton>
              </Tooltip>
          </div>
            <small className="text-white-50 d-block pt-3">             
                    <p>© Copyright {1900 + new Date().getYear()}{" "} CT-Onlinq</p>
            </small>
        </Container>
      </div>
    </footer>
  </div>

  );
}
